import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWindowSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWindowSquare"><Path d="M21 21H3V11H21V21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 9H3V3H21V9ZM6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5ZM8.5 5C7.94772 5 7.5 5.44772 7.5 6C7.5 6.55228 7.94772 7 8.5 7C9.05228 7 9.5 6.55228 9.5 6C9.5 5.44772 9.05228 5 8.5 5ZM11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWindowSquare;
